import { useEffect } from "react";
import React, { Component } from 'react';

// import { useLocation } from "react-router-dom";

export default class ScrollToTop extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="common-scroll-to-top">
        Component content: common/ScrollToTop
      </div>
    );
  }
}



// function ScrollToTop({ children }) {
//   // const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return children;
// }

// export default ScrollToTop;


// WEBPACK FOOTER //
// ./src/features/common/ScrollToTop.js